<template>
<footer>
  <div class="footer-block">
  <div class="footer-logo">
    <img src="/img/logo_header.jpg" alt="Medex Solution">
  </div>

  <div class="footer-address">
    <div class="footer-title">{{ $t('footer.footer-title')}}</div>
    <span>{{ $t('footer.span1')}}</span>
    <span>{{ $t('footer.span2')}}</span>
    <span>{{ $t('footer.span3')}}</span>
    <span>{{ $t('footer.span4')}}</span>
  </div>

  <div class="footer-requisites">
    <div class="footer-title">{{ $t('footer.footer-title1')}}</div>
    <span>{{ $t('footer.span11')}}</span>
    <span>{{ $t('footer.span22')}}</span>
    <span>{{ $t('footer.span33')}}</span>
  </div>

  <div class="top-bar-left">
      <a href="tel:+998998875888" class="header-phone">
           +998 99-887-58-88
      </a>
      <a href="mailto:info@medexsolution.uz" class="header-mail">
        info@medexsolution.uz
      </a>
  </div>


  <div class="footer-locations">
    <a href="https://maps.google.com/?q=41.32176918045978, 69.30282172751889" id="google" target="_blank" class="map-btn">{{ $t('footer.google')}}</a>
    <a href="https://yandex.uz/maps/10335/tashkent/?utm_medium=mapframe&utm_source=maps" id="yandex" target="_blank" class="map-btn map-btn--outline">{{ $t('footer.yandex') }}</a>
  </div>
</div>

  <div class="footer-copyright">
    {{ $t('footer.copyright')}}
  </div>

</footer>


</template>

<script>
export default {
  methods: {
    switchLang(lang) {
      this.$i18n.locale = lang
    }
  }
}
</script>

<style scoped>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto";
}

.footer {
  background-color: rgb(51, 50, 50);
  color: #fff;
  padding: 40px 20px 30px;
  gap: 40px;
  width: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
}

.footer-block {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
  background-color: rgb(51, 50, 50);
  color: #fff;
  padding-top: 30px;
  padding-bottom: 30px;
  gap: 40px;
  width: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
}

.footer-logo img {
  width: 100px;
  height: auto;
  border-radius: 100%;
  margin-left: 50px;
}

.underlogotext {
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 200;
  margin-left: 51px
}

.footer-address{
  display: grid;
  flex-direction: row;
  gap: 8px;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 200;

}

.footer-requisites {
  display: grid;
  flex-direction: row;
  gap: 8px;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 200;

}

.footer-title {
  font-size: 18px;
  font-weight: 200;
  font-family: "Roboto Condensed", sans-serif;
  margin-bottom: 10px;
}

.footer-locations {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
}

.map-btn {
  padding: 10px 16px;
  background: #309795;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  text-decoration: none;
  font-family: "Roboto Condensed", sans-serif;
  transition: background .2s ease, transform .15s ease;
  font-weight: 200;
  margin-right: 50px;
}

.map-btn:hover {
  background: #309795;
  transform: translateY(-2px);
}

.map-btn--outline {
  background: #309795;
  color: #ffffff;
  border: 2px solid #309795;
}

.map-btn--outline:hover {
  background: rgba(46, 125, 50, 0.08);
}

.footer-copyright {
  font-size: 14px;
  color: rgb(255, 255, 255);
  text-align: center;
  padding-top: 20px;
  border-color: 1px solid #ffffff;
  margin-top: -35px;
  font-weight: 100;
  font-family: "Roboto Condensed", sans-serif;
}

#google {
  display: grid;
  flex-direction: column;
  padding: 10px 23px;
  
}

#yandex {
  display: flex;
  flex-direction: column;
  
}

.header-phone {
    color: #fff;
    font-size: 13px;
    font-weight: 300;
    line-height: normal;
    position: relative;
    padding-left: 20px;
    text-decoration: none;
}

.fa-phone {
    position: absolute;
    top: 50%;
    left: 0;
    width: 14px;
    height: 14px;
    margin-top: -7px;
}

.header-mail{
    color: #fff;
    font-size: 13px;
    font-weight: 300;
    line-height: normal;
    margin-left: 62px;
    padding-left: 20px;
    text-decoration: none;
    display: flex;
    gap: 10px; 
    transition: 300ms;
    cursor: pointer;
}

.header-mail:hover{
    color: #00a2a5;
}

.top-bar-left {
    display: flex;
    align-items: center;
}




/* адаптив */





@media (min-width: 768px) and (max-width: 1023px) {
  .footer-block { gap: 24px; padding-left: 20px; padding-right: 20px; }
}

@media (min-width: 576px) and (max-width: 767px) {
  .footer-block { flex-direction: column; align-items: flex-start; gap: 16px;padding-left: 20px; padding-right: 20px; }
  .footer-logo img { margin-left: 0; }
}

@media (max-width: 575px) {
  .footer-block { flex-direction: column; gap: 14px; padding: 24px 12px; }
  .footer-locations { width: 100%; }
  .map-btn { width: 100%; text-align: center; margin-right: 0; }
}

@media (max-width: 575px) {
  .footer {padding: 30px 15px 20px;}
  .footer-block {padding: 20px 15px;gap: 20px;}
  .footer-logo img {width: 80px;}
  .footer-title {font-size: 16px;}
  .map-btn {font-size: 12px;padding: 8px 12px;}
  .footer-copyright {font-size: 12px;padding-top: -20px;}
  .top-bar-left{flex-direction: column;display: flex;align-items: stretch;}
  .header-mail{margin-left: 0;}
}


</style>